import { render, staticRenderFns } from "./IssueAction.vue?vue&type=template&id=7ccbc9fa&scoped=true&"
import script from "./IssueAction.vue?vue&type=script&lang=js&"
export * from "./IssueAction.vue?vue&type=script&lang=js&"
import style0 from "./IssueAction.vue?vue&type=style&index=0&id=7ccbc9fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccbc9fa",
  null
  
)

export default component.exports